.root {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.group {
  border: 1px solid var(--color-border);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 12px;
}

.group-legend {
  color: var(--color-foreground);
  font-size: 13px;
  font-weight: 600;
  padding: 0 6px;
}

.group-hint {
  color: var(--color-muted-foreground);
  margin: 0;
}

.options {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.option {
  align-items: flex-start;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  padding: 8px;
  transition: background-color 0.12s ease, border-color 0.12s ease;
}

.option:hover {
  background-color: var(--color-muted);
}

.option-is-checked {
  align-items: flex-start;
  background-color: var(--color-accent);
  border: 1px solid var(--color-primary);
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  gap: 10px;
  padding: 8px;
  transition: background-color 0.12s ease, border-color 0.12s ease;
}

// Match the checkbox box height to the header line so it centers against the
// label + badge row instead of riding above it.
.checkbox {
  cursor: pointer;
  flex-shrink: 0;
  height: 16px;
  margin-top: 4px;
  width: 16px;
}

// Eleggia rows carry a clearance badge, making the label line taller — nudge
// the checkbox down so it centers against that line (overrides the base).
.checkbox-with-badge {
  margin-top: 8px;
}

.option-body {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.option-header {
  align-items: center;
  display: flex;
  gap: 8px;
  min-height: 22px;
}

.option-label {
  color: var(--color-foreground);
  font-size: 13px;
  font-weight: 500;
  line-height: 22px;
}

.option-description {
  color: var(--color-muted-foreground);
  font-size: 12px;
  line-height: 1.4;
}
